import { createContext } from "react";
import type { OrganizationMember } from "@common/dto/organization/organization-member.dto";
import type { ApplyCloseTemplateEntityRow } from "./applyCloseTemplate.schema";
import type { WorkspaceMemberForClientAssignment } from "./applyCloseTemplateOrganizationMembers";

export interface TemplateApplicationContextValue {
    members: OrganizationMember[];
    getMemberLabel: (userId: number | null) => string;
    /** Workspace members keyed by workspaceId — includes non-org members. */
    workspaceMembersMap: Record<string, WorkspaceMemberForClientAssignment[]>;
    getEntityRow: (
        entityIdStr: string,
    ) => ApplyCloseTemplateEntityRow | undefined;
    setEntityRowField: <K extends keyof ApplyCloseTemplateEntityRow>(
        entityIdStr: string,
        field: K,
        value: ApplyCloseTemplateEntityRow[K],
    ) => void;
}

export const TemplateApplicationContext =
    createContext<TemplateApplicationContextValue | null>(null);
